<template>
  <div class="content">
    <!-- 面包屑 -->
    <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">固件升级</li>
      </ul>
    </div>
    <!-- tab页 -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName" @tab-click="changeTab()">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="levelList">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 固件列表
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom1">搜索</button>
          <button class="OrangeSmBtn" @click="reset1">重置</button>
          <!-- <button class="GreenSmBtn" @click="Out">导出</button> -->
          <button class="GreenSmBtn" @click="addNew">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="设备厂家">
                <el-select
                  placeholder="请选择设备厂家"
                  v-model="seefrom.factoryId"
                  @change="initFactoryName"
                >
                  <el-option
                    v-for="item in factoryList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备型号">
                <el-input placeholder="请输入设备型号" v-model="seefrom.model"></el-input>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select placeholder="请选择设备类型" v-model="seefrom.device_type">
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="固件版本">
                <el-input placeholder="请输入固件版本" v-model="seefrom.version"></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/firmWare/findAll"
            :parent="self"
            :config="config"
            :other="other1"
            ref="firmware1"
          >
            <template slot="last">
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteFirm(scope.$index, scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- dialog -->
        <el-dialog
          class="editDialog"
          :visible.sync="levelFirmVisible"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form :model="firmlevel" :rules="rules1" ref="firmlevel">
            <el-form-item label="设备类型" prop="device_type">
              <el-select placeholder="请选择设备类型" v-model="firmlevel.device_type">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备厂家" prop="factory">
              <el-select
                placeholder="请选择设备厂家"
                v-model="firmlevel.factoryId"
                @change="initDeviceMode"
              >
                <el-option
                  v-for="item in factoryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备型号" prop="model">
              <!-- <el-input placeholder="请输入设备型号" v-model="firmlevel.device_model"></el-input> -->
              <el-select
                placeholder="请选择设备型号"
                v-model="firmlevel.device_model"
                @change="deviceModeChange"
              >
                <el-option
                  v-for="item in deviceModeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="固件版本" prop="version">
              <el-input placeholder="请输入固件版本" v-model="firmlevel.version"></el-input>
            </el-form-item>
            <el-form-item label="固件描述" prop="remark">
              <el-input type="textarea" placeholder="请输入固件描述" v-model="firmlevel.remark"></el-input>
            </el-form-item>
            <el-form-item label="选择固件">
              <!-- <el-button>上传文件</el-button>
              <el-progress :text-inside="true" :stroke-width="20" :percentage="90"></el-progress>-->
              <input
                type="file"
                ref="clearFile"
                @change="getFile($event)"
                multiple="multiplt"
                class="add-file-right-input"
                style="margin-left:70px;"
              />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="levelFirmVisible = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd()">添 加</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>

      <!-- 固件升级 -->
      <el-tab-pane name="levelUp">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 固件升级
        </span>
        <levelup v-if="tabName === 'levelUp'"></levelup>
      </el-tab-pane>

      <!-- 升级任务 -->
      <el-tab-pane name="levelTask">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 升级任务
        </span>
        <div v-if="tabName === 'levelTask'">
          <div class="w_normalNav">
            <button class="BlueSmBtn" @click="subSeefrom3">搜索</button>
            <button class="OrangeSmBtn" @click="reset3">重置</button>
          </div>
          <div class="searchForm1">
            <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
              <template slot="last">
                <el-form-item label="设备区域">
                  <el-input
                    placeholder="请选择区域"
                    v-model="seefrom1.curAreaName"
                    @focus="changeAreaMode(1)"
                  ></el-input>
                </el-form-item>
                <el-form-item label="应用系统">
                  <el-select placeholder="请选择应用系统" v-model="seefrom1.system_id">
                    <el-option
                      v-for="item in SystemId"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <!-- <el-input placeholder="请输入应用系统" v-model="seefrom1.system_id"></el-input> -->
                </el-form-item>
                <el-form-item label="设备类型">
                  <el-select placeholder="请选择设备类型" v-model="seefrom1.device_type">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.typeName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="升级状态">
                  <el-select placeholder="请选择升级状态" v-model="seefrom1.status">
                    <el-option
                      v-for="item in levelStatus"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <!-- <el-input placeholder="请输入升级状态" v-model="seefrom1.status"></el-input> -->
                </el-form-item>
                <br />
                <el-form-item label="设备厂家">
                  <el-select
                    placeholder="请选择设备厂家"
                    v-model="seefrom1.factoryId"
                    @change="initDeviceMode1"
                  >
                    <el-option
                      v-for="item in factoryList1"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="设备型号">
                  <el-input placeholder="请输入设备型号" v-model="seefrom1.model"></el-input>
                </el-form-item>
                <el-form-item label="设备编号">
                  <el-input placeholder="请输入设备编号" v-model="seefrom1.device_id"></el-input>
                </el-form-item>
              </template>
            </searchForm>
          </div>
          <div class="tableWrapper" v-loading="!showTable">
            <!-- 后端分页 -->
            <easyTable
              apiUrl="operation/firmWareTask/findAll"
              :parent="self"
              :config="config2"
              :other="other3"
              ref="firmware3"
            >
              <!-- <template slot="last">
              <el-table-column label="操作" align="center" width="180">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="see(scope.$index,  scope.row)"
                  >详情</el-link>
                  <el-link icon="iconfont iconedit" type="text" size="small">回滚</el-link>
                </template>
              </el-table-column>
              </template>-->
            </easyTable>
          </div>
          <!-- dialog -->
          <!-- <el-dialog
          class="editDialog"
          :visible.sync="formVisible"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form :model="firmlevel1">
            <el-form-item label="设备类型">
              <el-input placeholder="请选择设备类型" v-model="firmlevel1.device_type"></el-input>
            </el-form-item>
            <el-form-item label="设备厂家">
              <el-input placeholder="请选择设备厂家" v-model="firmlevel1.factory"></el-input>
            </el-form-item>
            <el-form-item label="设备型号">
              <el-input placeholder="请输入设备型号" v-model="firmlevel1.device_model"></el-input>
            </el-form-item>
            <el-form-item label="固件版本">
              <el-input placeholder="请输入固件版本" v-model="firmlevel1.level"></el-input>
            </el-form-item>
          </el-form>
          </el-dialog>-->
          <!-- 区域树 -->
          <mountPoint
            :hasChildNodes="areaTreeMode"
            :dialogVisible="areaTreeVisible"
            @regionTreeClose="areaTreeVisible=false"
            @regionTreeData="selRegionData"
          ></mountPoint>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      tabName: "levelList",
      loading: true,
      form_jsgl: {},
      showTable: true,
      levelFirmVisible: false,
      formVisible: false,
      items: [],
      //区域树
      areaTreeVisible: false,
      //区域树模式选择
      areaTreeMode: true,
      //设备类型
      options: [],
      //设备厂家
      factoryList: [],
      factoryList1: [],
      //设备型号
      deviceModeList: [],
      //上传文件
      addArr: [],
      //应用系统
      SystemId: [],
      //升级状态
      levelStatus: [
        { id: 0, label: "升级中" },
        { id: 1, label: "升级成功" },
        { id: 2, label: "升级失败" }
      ],
      seefrom: {
        device_type: "",
        factory: "",
        factoryId: null,
        model: "",
        version: ""
      },
      firmlevel: {
        device_type: "",
        factory: "",
        factoryId: null,
        model: "",
        device_model: null,
        version: "",
        remark: ""
      },
      // firmlevel1: {
      //   device_type: "",
      //   factory: "",
      //   device_model: "",
      //   level: ""
      // },
      seefrom1: {
        curAreaName: "",
        system_id: "",
        device_type: "",
        status: "",
        factory: "",
        factoryId: null,
        model: "",
        device_id: ""
      },
      other1: {},
      other2: {},
      other3: {},
      rules1: {
        device_type: [
          { required: true, message: "请输入设备类型", trigger: "blur" }
        ],
        factory: [
          { required: true, message: "请输入设备厂家", trigger: "blur" }
        ],
        device_model: [
          { required: true, message: "请输入设备型号", trigger: "blur" }
        ],
        level: [
          { required: true, message: "请输入固件版本", trigger: "blur" },
          { max: 20, message: "不能超过20字符", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "typeName",
          label: "设备类型"
        },
        {
          prop: "factory",
          label: "厂家名称"
        },
        {
          prop: "model",
          label: "设备型号"
        },
        {
          prop: "create_time",
          label: "固件添加时间"
        },
        {
          prop: "version",
          label: "版本"
        },
        {
          prop: "remark",
          label: "描述"
        }
      ];
    },
    config1() {
      return [
        {
          prop: "a",
          label: "所属单位"
        },
        {
          prop: "b",
          label: "应用系统"
        },
        {
          prop: "c",
          label: "设备类型"
        },
        {
          prop: "d",
          label: "设备编号"
        },
        {
          prop: "region",
          label: "设备厂家"
        },
        {
          prop: "f",
          label: "设备型号"
        },
        {
          prop: "g",
          label: "固件更新时间"
        },
        {
          prop: "h",
          label: "当前版本"
        }
      ];
    },
    config2() {
      return [
        {
          prop: "name",
          label: "区域"
        },
        {
          prop: "systemName",
          label: "应用系统"
        },
        {
          prop: "typeName",
          label: "设备类型"
        },
        {
          prop: "deviceId",
          label: "设备编号"
        },
        {
          prop: "factory",
          label: "设备厂家"
        },
        {
          prop: "model",
          label: "设备型号"
        },
        {
          prop: "localVersion",
          label: "当前版本"
        },
        {
          prop: "targetVersion",
          label: "目标版本"
        },
        {
          prop: "create_time",
          label: "升级时间"
        },
        {
          prop: "statusName",
          label: "升级状态"
        }
      ];
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    mountPoint: () => import("public/mountPoint"),
    levelup: () => import("./levelUp/index")
  },
  methods: {
    //tab页切换
    changeTab() {
      if (name === "levelList") {
        this.tabName === "levelList";
      } else if (name === "levelUp") {
        this.tabName === "levelUp";
      } else if (name === "levelTask") {
        this.tabName === "levelTask";
      }
    },
    //搜索
    subSeefrom1() {
      this.other1 = this.seefrom;
      this.$nextTick(this.$refs.firmware1.getData);
    },
    subSeefrom2() {
      this.other2 = this.seefrom2;
      this.$nextTick(this.$refs.firmware2.getData);
    },
    subSeefrom3() {
      this.other3 = this.seefrom1;
      this.$nextTick(this.$refs.firmware3.getData);
    },
    //重置
    reset1() {
      this.seefrom.device_type = "";
      this.seefrom.factory = "";
      this.seefrom.factoryId = "";
      this.seefrom.version = "";
      this.seefrom.model = "";
    },
    reset2() {
      this.seefrom2.typeName = "";
      this.seefrom2.factory = "";
      this.seefrom2.version = "";
      this.seefrom2.model = "";
    },
    reset3() {
      this.seefrom1.device_type = "";
      this.seefrom1.factory = "";
      this.seefrom1.factoryId = "";
      this.seefrom1.version = "";
      this.seefrom1.model = "";
      this.seefrom1.device_id = "";
      this.seefrom1.curAreaName = "";
      this.seefrom1.system_id = "";
    },
    //固件列表--厂家ID厂家名称
    initFactoryName(factoryID) {
      let factoryId = factoryID || this.seefrom.factoryId;
      let temp = this.factoryList.find(it => it.id === factoryId);
      if (temp) {
        this.seefrom.factory = temp.name;
      }
    },
    //固件列表--监听设备厂家
    initDeviceMode(factoryID) {
      //console.log(factoryID);
      let factoryId = factoryID || this.firmlevel.factoryId;
      let temp = this.factoryList.find(it => it.id === factoryId);
      if (temp) {
        this.firmlevel.factory = temp.name;
      }
      //console.log(this.firmlevel.factory);
      this.$axiosget("operation/dictionaryData/queryList", {
        params: {
          dicType: this.firmlevel.factoryId
        }
      }).then(res => {
        if (res.data.status === "10000") {
          this.deviceModeList = res.data.data.list;
        }
      });
    },
    //固件列表--监听设备型号
    deviceModeChange() {
      let deviceMode = this.firmlevel.device_model;
      //console.log(deviceMode);
      let temp = this.deviceModeList.find(it => it.id === deviceMode);
      if (temp) {
        this.firmlevel.model = temp.name;
      }
      //console.log(this.firmlevel.model);
    },
    //固件列表--删除
    deleteFirm(index, row) {
      this.$confirm("是否删除该固件？", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiosdelete("operation/firmWare/delete", {
          params: {
            id: row.id
          }
        }).then(res => {
          if (res.data.status === "10000") {
            this.$message({ type: "success", message: "删除成功!" });
          }
          this.subSeefrom1();
        });
      });
    },
    //固件列表--上传文件
    getFile(event) {
      var file = event.target.files;

      for (var i = 0; i < file.length; i++) {
        //   //    上传类型判断
        //   var imgName = file[i].name;
        //   var idx = imgName.lastIndexOf(".");
        //   if (idx != -1) {
        //     var ext = imgName.substr(idx + 1).toUpperCase();
        //     ext = ext.toLowerCase();
        //     if (ext != "pdf" && ext != "doc" && ext != "docx") {
        //     } else {
        this.addArr.push(file[i]);
        //     }
        //   } else {
        //   }
      }
      // //console.log(this.addArr);
    },
    //固件列表--新增
    addNew() {
      this.title = "添加新固件";
      this.levelFirmVisible = true;
      this.firmlevel.device_type = "";
      this.firmlevel.factory = "";
      this.firmlevel.device_model = "";
      this.firmlevel.level = "";
    },
    //固件列表--确定
    submitAdd() {
      if (this.addArr.length == 0) {
        this.$message({
          type: "info",
          message: "请选择要上传的文件"
        });
        return;
      }
      //console.log(this.$refs["firmlevel"]);
      var formData = new FormData();
      formData.append("device_type", this.firmlevel.device_type);
      formData.append("factory", this.firmlevel.factory);
      formData.append("model", this.firmlevel.model);
      formData.append("version", this.firmlevel.version);
      formData.append("remark", this.firmlevel.remark);
      // formData.append("file", this.addArr);
      for (var i = 0; i < this.addArr.length; i++) {
        formData.append("file", this.addArr[i]);
      }
      // let config = {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //     Authorization: this.token
      //   }
      // };
      this.$refs["firmlevel"].validate(valid => {
        if (valid) {
          this.$axiospost("zuul/operation/firmWare/save", formData).then(
            res => {
              if (res.data.status === "10000") {
                this.levelFirmVisible = false;
                this.$message.success("新增成功！");
                this.subSeefrom1();
              } else {
                this.$message.danger("新增失败！");
                this.subSeefrom1();
              }
            }
          );
        }
      });
    },
    //固件列表--导出
    Out() {},

    // see(index, row) {
    //   this.title = "详情";
    //   this.formVisible = true;
    //   this.firmlevel1.device_type = row.device_type;
    //   this.firmlevel1.factory = row.factory;
    //   this.firmlevel1.device_model = row.device_model;
    //   this.firmlevel1.level = row.level;
    // },

    //升级任务--选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true;
      if (mode === 1) this.areaTreeMode = true;
      if (mode === 2) this.areaTreeMode = false;
      this.areaMode = mode;
    },
    //升级任务--区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      if (mode === 1) {
        this.seefrom1.region_id = a.id;
        this.seefrom1.curAreaName = a.name;
      } else if (mode === 2) {
        if (!a.type || a.type !== 1) {
          this.$set(this.addEquipment, "region", null);
          this.addEquipment.regionName = "";
          return;
        }
        this.$set(this.addEquipment, "region", a.id);
        this.addEquipment.regionName = a.name;
      }
    },
    //固件列表--监听设备厂家
    initDeviceMode1(factoryID) {
      //console.log(factoryID);
      let factoryId = factoryID || this.seefrom1.factoryId;
      let temp = this.factoryList1.find(it => it.id === factoryId);
      if (temp) {
        this.seefrom1.factory = temp.name;
      }
      //console.log(this.seefrom1.factory);
    }

    //固件升级--升级
    // upgrade() {
    //   this.$router.push({ name: "levelUp" });
    // }
  },
  created() {
    //初始化设备类型
    this.$axiosget("manager/devicetype/list").then(res => {
      this.options = res.data.data;
    });
    //初始化设备厂家
    this.$axios
      .get(process.env.API_HOST + "operation/dictionaryType/queryList", {
        params: {
          key: "FACTORY"
        }
      })
      .then(res => {
        this.factoryList = res.data.data.list || [];
        this.factoryList1 = res.data.data.list || [];
        //console.log(this.factoryList);
      });
    //初始化应用系统
    this.$axiosget(
      "manager/operatingSystemApi/getOperatingSystemsByCompanyId",
      {
        params: {
          compayId: localStorage.getItem("companyId")
        }
      }
    ).then(res => {
      this.SystemId = res.data.data;
    });
  }
};
</script>

<style scope lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
/deep/ .el-textarea__inner {
  border: 1px solid #3d4963;
  width: 310px;
  background: transparent;
  color: #cacaca;
  font-family: "Microsoft YaHei", "SF Pro Display", Roboto, Noto, Arial,
    "PingFang SC", sans-serif;
}
.el-progress {
  margin-left: 5px;
  width: 200px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/firmware.vue